export const breadcrumb = {
  title: 'Телефонные номера',
  number: {
    buy: 'Купить',
    index: 'Список'
  }
};
